import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GROUP_BY_UUID_RESOURCE } from "../group/use-group-by-uuid.query";
import { USER_APP_ROLE_RESOURCE } from "../user/use-user-app-role.query";

export const RULE_CREATE_RESOURCE = "rule" as const;
export const RULE_CREATE_API_PATH = `/v1/${RULE_CREATE_RESOURCE}` as const;

export type RuleCreateBody = paths[typeof RULE_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type RuleCreateResponse =
  paths[typeof RULE_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useRuleCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RuleCreateResponse, Error, RuleCreateBody>({
    mutationFn: async (rule: RuleCreateBody) => {
      const response = await alphartisApiAxios.post<RuleCreateResponse>(RULE_CREATE_API_PATH, rule);
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [RULE_CREATE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [GROUP_BY_UUID_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [USER_APP_ROLE_RESOURCE],
        }),
      ]);
    },
  });
};
